import { io } from 'socket.io-client';

import socketBaseUrl from './socketBaseUrl';

const socketOptimizer = io(`${socketBaseUrl}/optimizer-progress`, {
  transports: ['websocket'],
  autoConnect: false,
});

export default socketOptimizer;
